import { Compass, Lock } from 'lucide-react';
import { Link } from 'react-router';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/common/page';

export function NotFoundPage({ standalone }: { standalone?: boolean }) {
  return (
    <div className={standalone ? 'flex min-h-svh items-center justify-center p-6' : 'page-gutter py-16'}>
      <EmptyState icon={Compass} title="Page not found" description="The page you’re looking for doesn’t exist or has moved." action={<Button asChild><Link to="/dashboard">Back to dashboard</Link></Button>} />
    </div>
  );
}

export function AccessDenied({ what }: { what?: string }) {
  return (
    <div className="page-gutter py-16">
      <EmptyState
        icon={Lock}
        title="You don’t have access to this"
        description={`${what ?? 'This area'} isn’t available for your role. Ask an owner or administrator if you need it.`}
        action={<Button asChild variant="secondary"><Link to="/dashboard">Back to dashboard</Link></Button>}
      />
    </div>
  );
}
